$(function(){
    if($("#application_project_responsible_identical_no").length) {
        $(".radio").click(check_application_project_responsible_identical_no_selected);
        check_application_project_responsible_identical_no_selected()
    }
    if($("#application_budget_yes").length) {
        $(".radio").click(check_application_budget_yes_selected);
        check_application_budget_yes_selected()
    }

    if($("#application_financed_yes").length) {
        $(".radio").click(check_application_financed_yes_selected);
        check_application_financed_yes_selected()
    }

    if($("#application_part_of_other").length) {
        $(".radio").click(check_part_of_other_selected);
        check_part_of_other_selected()
    }

    if($("#application_extract_type_priority1").length){
        $("select[id^='application_extract_type_priority']").change(check_application_extract_type_priority);
        check_application_extract_type_priority()
    }

    init_check_population_units_category("#application_databases");
    $('form.simple_form.edit_application').on('cocoon:after-insert', function(e,item) {
        init_check_population_units_category(item)
    });

    if($(".acknowledged-by-authority-checkbox").length){
        $(".acknowledged-by-authority-checkbox").change(check_acknowledged_by_authority_checkboxes)
        check_acknowledged_by_authority_checkboxes()
    }
});

function check_application_project_responsible_identical_no_selected(){
    if ($("#application_project_responsible_identical_no")[0].checked == true) {
        $("div.application_project_responsible_name").show()
        $("div.statement_list").show()
    } else {
        $("div.application_project_responsible_name").hide()
        $("div.statement_list").hide()
    }
}

function check_part_of_other_selected() {
    if ($("#application_part_of_other")[0].checked == true) {
        $("div.application_part_of_other_text").show()
    } else {
        $("div.application_part_of_other_text").hide()
    }
}

function check_application_budget_yes_selected(){
    if ($("#application_budget_yes")[0].checked == true) {
        $("div.form-group.budget_list").show()
    } else {
        $("div.form-group.budget_list").hide()
    }
}

function check_application_financed_yes_selected(){
    if ($("#application_financed_yes")[0].checked == true) {
        $("div.application_financed_description").show()
    } else {
        $("div.application_financed_description").hide()
    }
}

function check_application_extract_type_priority(){
    if ($("select[id^='application_extract_type_priority'] option:selected[value='Andet']").length) {
        $("div.application_extract_type_other").show()
    } else {
        $("div.application_extract_type_other").hide()
    }
}


function init_check_population_units_category(target){
    if(target == undefined) {
        target = 'body'
    }
    $(target).find("input[type='radio']").each(function(){
        $(this).closest("span.radio").click(check_population_units_category)
    });
    check_population_units_category()
}

function check_population_units_category() {
    $("input[type='radio'][value='regional']").each(function(){
        parent_panel = $(this).closest("div.panel-body");
        target_field = $(parent_panel).find("div.application_application_databases_population_units");
        if($(this).prop('checked') === true){
            target_field.show();
        }else{
            target_field.hide();
        }
    });
}

function check_acknowledged_by_authority_checkboxes(){
    $(".acknowledged-by-authority-checkbox").each(function(){
        if (this.checked)
            $(this).parent().parent().parent().next(".acknowledged-by-attributes").show()
        else
            $(this).parent().parent().parent().next(".acknowledged-by-attributes").hide()
    })
}

function toggle_collapse(element){
    $(element).parents('.panel').find('.panel-body').collapse('toggle')
}



